export default "__VITE_ASSET__d69fdacd__"